import {ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

type TaskType = 'TASK' | 'MEETING' | 'CALL' | undefined;

export function getTaskIcon(type: TaskType): ThemeIconKey {
  return match<TaskType, ThemeIconKey>(type)
    .with('TASK', () => 'content/paste')
    .with('MEETING', () => 'action/calendar_today')
    .with('CALL', () => 'action/settings_phone')
    .otherwise(() => 'content/paste');
}
